import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { testimonials } from '../constants';

export function StoriesSection() {
    return (
        <section id="stories" className="grid gap-6 md:grid-cols-2">
            {testimonials.map((story) => (
                <Card
                    key={story.name}
                    className={cn(
                        'flex h-full flex-col justify-between gap-6 border-slate-200/70 bg-white/80 p-7 shadow-sm backdrop-blur-sm dark:border-slate-700/60 dark:bg-gray-900/70',
                    )}
                >
                    <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300">
                        {story.quote}
                    </p>
                    <div className="space-y-1 text-sm">
                        <p className="font-semibold text-slate-900 dark:text-white">
                            {story.name}
                        </p>
                        <p className="text-slate-500 dark:text-slate-400">
                            {story.stay}
                        </p>
                    </div>
                </Card>
            ))}
        </section>
    );
}
